<div class="container">
  <div fxLayout="row wrap" fxFlex="100">
    <div class="breadcrumb" fxFlex="30" fxLayoutAlign="start">
      <p> <a [routerLink]="'/dashboard'" class="breadcrumb-link">Home</a> / <span>Device Logs</span> </p>
    </div>

    <div fxLayout="row" fxLayoutGap="20" fxLayoutAlign="center" class="field-container">
      <div fxLayout="column" fxLayoutGap="20">
        <mat-form-field appearance="outline" class="mat-form-field" fxFlex="50">
          <mat-label>Enter Serial Number</mat-label>
          <input matInput [(ngModel)]="enteredSerialNumber" (input)="onSerialNumberInput()">
        </mat-form-field>
      </div>

      <div fxLayout="column">
        <mat-form-field appearance="outline" class="mat-form-field">
          <mat-label>Start Date - End Date</mat-label>
          <mat-date-range-input [rangePicker]="rangePicker">
            <input matStartDate class="start-date" placeholder="MM/DD/YYYY" [(ngModel)]="enteredStartDate" [min]="minDate" name="enteredStartDate" (ngModelChange)="validateDateRange()" readonly>
            <input matEndDate class="end-date" placeholder="MM/DD/YYYY" [(ngModel)]="enteredEndDate" [min]="enteredStartDate" name="enteredEndDate" (ngModelChange)="validateDateRange()" readonly>
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
          <mat-date-range-picker #rangePicker>
            <mat-date-range-picker-actions>
              <button mat-button matDateRangePickerCancel class="calendar-cancel-button">Cancel</button>
              <button mat-raised-button class="apply-button" matDateRangePickerApply>Apply</button>
            </mat-date-range-picker-actions>
          </mat-date-range-picker>
        </mat-form-field>
      </div>

      <button mat-raised-button [ngClass]="isDateRangeValid && enteredSerialNumber ? 'mat-button-search' : 'disabled-button'" (click)="searchLogs()" [disabled]="!isDateRangeValid || !enteredSerialNumber">Search</button>
      <button mat-raised-button [ngClass]="selectedLog ? 'mat-button-search' : 'disabled-button'"  (click)="viewLog()" [disabled]="!selectedLog">View</button>
      <button mat-raised-button [ngClass]="selectedLog ? 'mat-button-search' : 'disabled-button'"  (click)="download()" [disabled]="!selectedLog">Download</button>
    </div> 
  </div>
</div>

<div class="error-container" fxLayout="column" fxLayoutAlign="center start">
  <div *ngIf="serialNumberError" class="error-message">{{serialNumberError}}</div>
  <div *ngIf="dateRangeError" class="error-message">{{dateRangeError}}</div>
</div>

<div *ngIf="searchClicked && !serialNumberError && !dateRangeError" class="container">
  <div fxLayout="row" class="device-logs-list" fxFlex="85" fxLayoutAlign="center">
    <mat-radio-group [(ngModel)]="selectedLog" fxFlex="100">
      <table class="log-table">
        <thead>
          <tr class="mat-card-title">
            <th class="sno-column">Select</th>
            <th (click)="sortData('date')" class="sortable date-column">
              <div class="th-content">
                Date ({{ timezone }})
                <svg
                  class="sort-icon"
                  [ngClass]="{ 'active': sortColumn === 'date' }"
                  [attr.data-sort-direction]="sortColumn === 'date' ? sortDirection : ''"
                  width="17" height="17" viewBox="0 0 24 24">
                  <polygon points="12,5 19,19 5,19"></polygon>
                </svg>
              </div>
            </th>
            
            <th (click)="sortData('file_size')" class="sortable size-column">
              <div class="th-content">
                Size (Bytes)
                <svg
                  class="sort-icon"
                  [ngClass]="{ 'active': sortColumn === 'file_size' }"
                  [attr.data-sort-direction]="sortColumn === 'file_size' ? sortDirection : ''"
                  width="17" height="17" viewBox="0 0 24 24">
                  <polygon points="12,5 19,19 5,19"></polygon>
                </svg>
              </div>
            </th>
            <th class="logs-column">Logs</th>      
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let log of sortedLogs">
            <td>
              <mat-radio-button [value]="log"></mat-radio-button>
            </td> 
            <td>{{ log.date | date : dateFormat }}</td> 
            <td>{{ log.file_size }}</td>
            <td>{{ log.file_path?.split('/').pop() || 'No Log Available' }}</td>
          </tr>
          <tr *ngIf="logs.length === 0">
            <td colspan="4" class="no-logs-message">No logs available.</td>
          </tr>
        </tbody>
      </table>
    </mat-radio-group>
  </div>
</div>

<div *ngIf="searchClicked && logs.length > 0 && !serialNumberError && !dateRangeError" class="pagination-controls" fxLayout="row" fxLayoutAlign="space-between center">
  <div class="pagination" fxFlexAlign="center">
    <button class="mat-button-prev" mat-raised-button (click)="prevPage()" [disabled]="currentPage === 1">Previous</button>
    <span class="page-button">Page {{ currentPage }} of {{ totalPages }}</span>
    <button class="mat-button-prev" mat-raised-button (click)="nextPage()" [disabled]="currentPage === totalPages">Next</button>
  </div>
  <div class="items">
    <mat-form-field appearance="outline" class="pagination-mat-form-field">
      <mat-select [placeholder]="defaultPlaceholder" [(value)]="pageSize" (selectionChange)="onPageSizeChange($event)">
        <mat-option value="5">5</mat-option>
        <mat-option value="10">10</mat-option>
        <mat-option value="15">15</mat-option>
        <mat-option value="20">20</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>